/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker } from '@material-ui/pickers';
import EventIcon from '@material-ui/icons/Event';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import PresentToAllIcon from '@material-ui/icons/PresentToAll';
import { Alert, AlertTitle } from '@material-ui/lab';
import Checkbox from '@material-ui/core/Checkbox';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import Card from 'src/components/sharedComponents/Card/Card';
import CardFooter from 'src/components/sharedComponents/Card/CardFooter';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardIcon from 'src/components/sharedComponents/Card/CardIcon';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import { ContextDownload } from 'src/context/ContextDownload';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ReportsPage = ({
  onsubmit,
  loading,
  onDateSelect,
  company,
  brand,
  categoty,
  segment,
  loading2,
  subRegion,
  region,
}) => {
  const [search, setSearch] = useState('');
  const [updateRegion, setUpdateRegion] = useState('');
  const [inputValue, setInputValue] = useState('');

  const [categoryUpdate, setCategoryUpdate] = useState(categoty);
  const [companys, setCompany] = useState(company);
  const [brands, setBrands] = useState(brand);
  const [categorys, setCategorys] = useState(categoty);
  const [segments, setSegments] = useState(segment);
  const [subRegions, setSubRegions] = useState(subRegion);
  const [regions, setRegions] = useState(region);

  const [flag, setFlag] = useState(false);
  const [flag2, seFlag2] = useState(false);
  const [buttonState, setButton] = useState(true);

  const DATE = new Date();
  const MONTH = DATE.getMonth();
  const YEAR = DATE.getFullYear();

  const { setUpdateCompany, setUpdateSegment, setUpdateCategory } = useContext(
    ContextDownload,
  );

  const MIN_DATE = new Date(YEAR - 1, MONTH - 1);

  const [date, setDate] = useState(DATE);

  const MONTH2 = date.getMonth();
  const YEAR2 = date.getFullYear();

  const lastDay = new Date(YEAR2, MONTH2 + 1, 0);
  const dataDay = lastDay.toString().split(/[ ,]/, 3);

  function convertDate(inputFormat) {
    function pad(s) {
      return s < 10 ? `0${s}` : s;
    }
    const d = new Date(inputFormat);
    return [d.getFullYear(), pad(d.getMonth() + 1)].join('/');
  }

  const onDateChange = (value) => {
    setDate(value);
  };

  useEffect(() => {
    setBrands(brand);
    setSegments(segment);
    setUpdateCompany(search);
    if (flag2 === false) {
      setCategorys(categoty);
    }
  }, [search, brand, segment, categoty]);

  useEffect(() => {
    setSubRegions(subRegion);
    setUpdateSegment(updateRegion);
  }, [updateRegion, subRegion]);

  useEffect(() => {
    setUpdateCategory(categoryUpdate);
  }, [categoryUpdate]);

  useEffect(() => {
    if (flag === true) {
      setCompany(company);
      setCategorys(categoty);
      setRegions(region);
    }
  }, [company, region, categoty]);

  const handleSelectMonth = (event) => {
    event.preventDefault();
    setButton(false);
    setFlag(true);
    onDateSelect({
      fecha_0: `${convertDate(date)}/1`,
      fecha_1: `${convertDate(date)}/${dataDay[2]}`,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onsubmit({
      empresas: companys,
      marcas: brands,
      categorys,
      segments,
      fecha_0: `${convertDate(date)}/1`,
      fecha_1: `${convertDate(date)}/${dataDay[2]}`,
      regiones: regions,
      subregiones: subRegions,
    });
  };

  return (
    <main style={{ margin: '10px' }}>
      <CardTitle title="Report download Center" />
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} sm={12}>
            <form
              noValidate
              autoComplete="off"
              onSubmit={handleSelectMonth}
            >
              <Card>
                <CardHeader color="customAuteco" stats icon>
                  <CardIcon color="customAuteco">
                    <PresentToAllIcon />
                  </CardIcon>
                </CardHeader>
                <CardBody>
                  <h3>Step1 - Select date range</h3>
                  <Grid style={{ marginLeft: '5px' }} container spacing={2}>
                    <Grid item xs={12} md={6} sm={12}>
                      <KeyboardDatePicker
                        autoOk
                        views={['year', 'month']}
                        variant="inline"
                        format="yyyy/MM"
                        margin="normal"
                        id="date-picker-inline"
                        invalidDateMessage="Select a date for the report"
                        label="Select Date"
                        disableFuture
                        minDate={MIN_DATE}
                        onChange={(day) => onDateChange(day)}
                        value={date}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                      <Button type="onSubmit " color="warning">
                        Filter selection
                      </Button>
                    </Grid>
                  </Grid>
                </CardBody>
              </Card>
            </form>
          </Grid>
          <Grid item xs={12} md={6} sm={12}>
            <div style={{ paddingTop: '30px' }}>
              <Alert severity="warning">
                <AlertTitle>Attention</AlertTitle>
                Follow all the steps to generate the report —
                {' '}
                <strong>Click the button generate report!</strong>
              </Alert>
            </div>
          </Grid>
          <Grid item xs={12} md={12} sm={12}>
            <form noValidate autoComplete="off">
              <Card>
                <CardHeader color="customAuteco" stats icon>
                  <CardIcon color="customAuteco">
                    <EventIcon />
                  </CardIcon>
                </CardHeader>
                <CardBody>
                  <h3>Step 2 - Filter items and Download</h3>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12} sm={12}>
                      <Autocomplete
                        multiple
                        value={companys}
                        disableCloseOnSelect
                        noOptionsText="Please select a date"
                        onChange={(event, newValue) => {
                          setFlag(false);
                          setSearch(newValue);
                          setCompany(newValue);
                          if (newValue.length === 0) {
                            setFlag(true);
                          }
                        }}
                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue);
                        }}
                        id="company-selector"
                        loading={loading}
                        options={company}
                        limitTags={3}
                        renderOption={(option, { selected }) => (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option}
                          </>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="1 - Company"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loading ? (
                                    <CircularProgress size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                      <Autocomplete
                        multiple
                        value={brands}
                        limitTags={3}
                        disableCloseOnSelect
                        noOptionsText="Please select a Company"
                        onChange={(event, newValue) => setBrands(newValue)}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue);
                        }}
                        id="brand-selector"
                        loading={loading}
                        options={brand}
                        renderOption={(option, { selected }) => (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option}
                          </>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="2 - Brand"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loading ? (
                                    <CircularProgress size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                      <Autocomplete
                        multiple
                        value={categorys}
                        limitTags={3}
                        disableCloseOnSelect
                        noOptionsText="Please select a brand"
                        onChange={(event, newValue) => {
                          setFlag(false);
                          seFlag2(true);
                          setCategorys(newValue);
                          setCategoryUpdate(newValue);
                          if (newValue.length === 0) {
                            setFlag(true);
                            setCategoryUpdate(categorys);
                          }
                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue);
                        }}
                        id="category-selector"
                        loading={loading}
                        options={categoty}
                        renderOption={(option, { selected }) => (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option}
                          </>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="3 - Category"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loading ? (
                                    <CircularProgress size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                      <Autocomplete
                        multiple
                        value={segments}
                        limitTags={2}
                        disableCloseOnSelect
                        onChange={(event, newValue) => setSegments(newValue)}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue);
                        }}
                        id="segment-selector"
                        loading={loading}
                        options={segment}
                        noOptionsText="Please select a category"
                        renderOption={(option, { selected }) => (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option}
                          </>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="4 - Segment"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loading ? (
                                    <CircularProgress size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                      <Autocomplete
                        multiple
                        value={regions}
                        limitTags={3}
                        disableCloseOnSelect
                        onChange={(event, newValue) => {
                          setFlag(false);
                          setRegions(newValue);
                          setUpdateRegion(newValue);
                          if (newValue.length === 0) {
                            setFlag(true);
                          }
                        }}
                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue);
                        }}
                        id="Region-selector"
                        loading={loading}
                        options={region}
                        renderOption={(option, { selected }) => (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option}
                          </>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="5 - Region"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loading ? (
                                    <CircularProgress size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                      <Autocomplete
                        multiple
                        value={subRegions}
                        limitTags={2}
                        disableCloseOnSelect
                        onChange={(event, newValue) => setSubRegions(newValue)}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue);
                        }}
                        id="region-selector"
                        loading={loading}
                        options={subRegion}
                        noOptionsText="Please select a region"
                        renderOption={(option, { selected }) => (
                          <>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option}
                          </>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="4 - Sub-Region"
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loading ? (
                                    <CircularProgress size={20} />
                                  ) : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </CardBody>
                <CardFooter>
                  {loading2 ? (
                    <>
                      <span>Generating report, wait...</span>
                      <CircularProgress />
                    </>
                  ) : (
                    <Button
                      disabled={buttonState}
                      type="onSubmit "
                      onClick={handleSubmit}
                      color="warning"
                    >
                      Generate Report
                    </Button>
                  )}
                </CardFooter>
              </Card>
            </form>
          </Grid>
          <div />
        </Grid>
      </div>
    </main>
  );
};

export default ReportsPage;
